(ns ductile.ui.load-builder
  (:require ["@radix-ui/react-context-menu" :as context-menu]
            ["@turf/turf" :as turf]
            [applied-science.js-interop :as j]
            [clojure.set :as set]
            [clojure.string :as str]
            [ductile.clerk.render :as ductile.render]
            [ductile.clerk.viewer :as ductile.viewer]
            [ductile.time.js-types :as time]
            [ductile.ui.components :as ui]
            [ductile.ui.components.columns :as columns]
            [ductile.ui.components.omnibox :as omnibox]
            [ductile.ui.components.table :as table]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.fields :as fields]
            [ductile.ui.http :as http]
            [ductile.ui.load-builder.overview-map :as overview-map]
            [ductile.ui.locale :as locale :refer [tr]]
            [ductile.ui.routes :as routes]
            [ductile.ui.transport :as transport]
            [ductile.ui.util :as util]
            [goog.functions :as gf]
            [nextjournal.clerk.render :as render]
            [nextjournal.clerk.render.hooks :as hooks]
            [nextjournal.clerk.render.localstorage :as localstorage]
            [nextjournal.clerk.render.panel :as panel]
            [nextjournal.clerk.viewer :as viewer]
            [reagent.core :as reagent]))

(def !selected-fahrzeuge
  (deframe/!route-get ::selected-fahrzeuge []))

(def !sorted-route
  (deframe/!route-get ::sorted-route))

(def !sort-by-distance?
  (deframe/!route-get ::sort-by-distance? true))

(def !route
  (deframe/!route-get ::route))

(def !selected-marker-ids
  (deframe/!route-get ::selected-marker-ids))

(def !filters
  (deframe/!route-get ::filters))

(def !show-map?
  (deframe/!localstorage-get ::show-map? true))

(def !show-loads?
  (deframe/!localstorage-get ::show-loads? false))

(def !show-waypoints?
  (deframe/!localstorage-get ::show-waypoints? true))

(def !transports-height
  (deframe/!localstorage-get ::transports-height 30))

(def !show-flows?
  (deframe/!localstorage-get ::show-flows?))

(def !pan-to-filter?
  (deframe/!localstorage-get ::pan-to-filter?))

(def !clerk-table?
  (deframe/!route-get ::clerk-table?))

(def tx!
  overview-map/tx!)

(defn current-route-template []
  (some-> @deframe/!current-route :template routes/path->template))

(defn show-fahrzeuge-on-transports-route-family
  ([] (show-fahrzeuge-on-transports-route-family (current-route-template)))
  ([template]
   (cond
     (#{'[load-builder :country/code]
        '[load-builder :country/code popup-map]}
      template)
     '[load-builder :country/code]

     (#{'[compound :compound-name load-builder]
        '[compound :compound-name load-builder popup-map]
        '[compound :compound-name load-builder elog]}
      template)
     '[compound :compound-name load-builder]

     (#{'[load-builder :country/code v2]
        '[load-builder :country/code v2 popup]}
      template)
     '[load-builder :country/code v2]

     (#{'[compound :compound-name load-builder-v2]
        '[compound :compound-name load-builder-v2 popup]}
      template)
     '[compound :compound-name load-builder-v2]

     (#{'[load-builder-v2 :country/code]
        '[load-builder-v2 :country/code popup]}
      template)
     '[load-builder-v2 :country/code]

     :else
     template)))

(defn show-fahrzeuge-on-transports-storage-key
  ([] (show-fahrzeuge-on-transports-storage-key (current-route-template)))
  ([template]
   (let [route-family (show-fahrzeuge-on-transports-route-family template)]
     (cond
       (= route-family '[load-builder :country/code])
       :ductile.ui.load-builder/show-fahrzeuge-on-transports.country-v1?

       (= route-family '[compound :compound-name load-builder])
       :ductile.ui.load-builder/show-fahrzeuge-on-transports.compound-v1?

       (= route-family '[load-builder :country/code v2])
       :ductile.ui.load-builder/show-fahrzeuge-on-transports.country-v2?

       (= route-family '[compound :compound-name load-builder-v2])
       :ductile.ui.load-builder/show-fahrzeuge-on-transports.compound-v2?

       (= route-family '[load-builder-v2 :country/code])
       :ductile.ui.load-builder/show-fahrzeuge-on-transports.country-v2-alt?

       :else
       :ductile.ui.load-builder/show-fahrzeuge-on-transports?))))

(defn default-show-fahrzeuge-on-transports?
  ([] (default-show-fahrzeuge-on-transports? (current-route-template)))
  ([template]
   (contains? #{'[load-builder :country/code]
                '[load-builder :country/code v2]}
              (show-fahrzeuge-on-transports-route-family template))))

(defn show-fahrzeuge-on-transports-setting
  ([] (show-fahrzeuge-on-transports-setting (current-route-template)))
  ([template]
   {:storage-key (show-fahrzeuge-on-transports-storage-key template)
    :default? (default-show-fahrzeuge-on-transports? template)}))

(defonce !perf
  (atom {:enabled? false
         :internal-enabled? false
         :samples  []
         :pending  {}}))

(defn perf-now []
  (.now js/performance))

(defn perf-enable! [enabled?]
  (swap! !perf assoc :enabled? (boolean enabled?)))

(defn perf-enable-internal! [enabled?]
  (swap! !perf assoc :internal-enabled? (boolean enabled?)))

(defn perf-reset! []
  (swap! !perf assoc :samples [] :pending {}))

(defn perf-track-click! [transport]
  (when (:enabled? @!perf)
    (let [id (:ductile/id transport)]
      (swap! !perf assoc-in [:pending id]
             {:ductile/id id
              :vehicle/vin (:vehicle/vin transport)
              :t-click (perf-now)}))))

(defn perf-track-toggle-dispatch! [transport]
  (when (and (:enabled? @!perf) (:internal-enabled? @!perf))
    (let [id (:ductile/id transport)]
      (swap! !perf update-in [:pending id]
             (fn [sample]
               (cond-> (or sample {:ductile/id id
                                   :vehicle/vin (:vehicle/vin transport)})
                 (nil? (:t-toggle-dispatch sample))
                 (assoc :t-toggle-dispatch (perf-now))))))))

(defn percentile [xs p]
  (let [n (count xs)]
    (when (pos? n)
      (nth xs (int (js/Math.min (dec n) (js/Math.floor (* p (dec n)))))))))

(defn perf-summary []
  (let [{:keys [samples internal-enabled? enabled?]} @!perf
        durations (sort (map :click-to-row-move-ms samples))
        click-to-dispatch (sort (keep :click-to-toggle-dispatch-ms samples))
        click-to-selected (sort (keep :click-to-selected-observed-ms samples))
        click-to-filtered (sort (keep :click-to-filtered-observed-ms samples))
        selected-to-filtered (sort (keep :selected-observed-to-filtered-observed-ms samples))]
    (cond-> {:enabled? enabled?
             :internal-enabled? internal-enabled?
             :count (count samples)
             :samples samples
             :p50 (percentile durations 0.5)
             :p95 (percentile durations 0.95)
             :max (last durations)}
      internal-enabled?
      (assoc :phases {:click_to_toggle_dispatch {:p50 (percentile click-to-dispatch 0.5)
                                                 :p95 (percentile click-to-dispatch 0.95)
                                                 :max (last click-to-dispatch)}
                      :click_to_selected_observed {:p50 (percentile click-to-selected 0.5)
                                                   :p95 (percentile click-to-selected 0.95)
                                                   :max (last click-to-selected)}
                      :click_to_filtered_observed {:p50 (percentile click-to-filtered 0.5)
                                                   :p95 (percentile click-to-filtered 0.95)
                                                   :max (last click-to-filtered)}
                      :selected_observed_to_filtered_observed {:p50 (percentile selected-to-filtered 0.5)
                                                               :p95 (percentile selected-to-filtered 0.95)
                                                               :max (last selected-to-filtered)}}))))

(defn perf-update! [filtered-fahrzeuge selected-fahrzeuge]
  (when (:enabled? @!perf)
    (let [internal-enabled? (:internal-enabled? @!perf)
          now (perf-now)
          filtered-ids (into #{} (map :ductile/id) filtered-fahrzeuge)
          selected-ids (into #{} (map :ductile/id) selected-fahrzeuge)
          {:keys [pending samples] :as state} @!perf
          {:keys [pending' completed]}
          (reduce-kv (fn [{:keys [pending' completed]} id sample]
                       (let [sample' (cond-> sample
                                       (and internal-enabled?
                                            (nil? (:t-selected-observed sample))
                                            (contains? selected-ids id))
                                       (assoc :t-selected-observed now)
                                       (and (nil? (:t-row-removed sample))
                                            (not (contains? filtered-ids id)))
                                       (assoc :t-row-removed now)
                                       (and (nil? (:t-row-added sample))
                                            (contains? selected-ids id))
                                       (assoc :t-row-added now))]
                         (if (and (:t-row-removed sample') (:t-row-added sample'))
                           {:pending' pending'
                            :completed (conj completed
                                             (cond-> (assoc sample'
                                                            :click-to-row-move-ms (- (max (:t-row-removed sample')
                                                                                          (:t-row-added sample'))
                                                                                     (:t-click sample')))
                                               internal-enabled?
                                               (assoc :click-to-toggle-dispatch-ms (when-let [t (:t-toggle-dispatch sample')]
                                                                                     (- t (:t-click sample')))
                                                      :click-to-selected-observed-ms (when-let [t (:t-selected-observed sample')]
                                                                                       (- t (:t-click sample')))
                                                      :click-to-filtered-observed-ms (when-let [t (:t-row-removed sample')]
                                                                                       (- t (:t-click sample')))
                                                      :selected-observed-to-filtered-observed-ms (when (and (:t-selected-observed sample')
                                                                                                            (:t-row-removed sample'))
                                                                                                   (- (:t-row-removed sample')
                                                                                                      (:t-selected-observed sample'))))))}
                           {:pending' (assoc pending' id sample')
                            :completed completed})))
                     {:pending' {}
                      :completed []}
                     pending)]
      (when (or (seq completed)
                (not= pending pending'))
        (reset! !perf (assoc state
                             :pending pending'
                             :samples (into samples completed)))))))

(defn install-perf-api! []
  (set! (.-ductileLoadBuilderPerf js/window)
        (clj->js {:enable (fn [enabled?] (perf-enable! enabled?))
                  :enableInternal (fn [enabled?] (perf-enable-internal! enabled?))
                  :reset perf-reset!
                  :summary (fn [] (clj->js (perf-summary)))}))
  nil)

(install-perf-api!)

(defn selected->waypoints [selected sorted]
  (let [waypoints (->> selected
                       (group-by :transport/destination)
                       (mapv (fn [[waypoint transports]]
                               (assoc waypoint :waypoint/transports transports))))]
    (if sorted
      (sort-by #(let [i (.indexOf sorted [(:location/longitude %)
                                          (:location/latitude %)])]
                  (if (< i 0) (count sorted) i))
               waypoints)
      waypoints)))

(def !waypoints
  (reagent/track (fn []
                   (selected->waypoints @!selected-fahrzeuge @!sorted-route))))

(defn suggestions-for-waypoint
  ([fahrzeuge waypoint]
   (suggestions-for-waypoint 5 fahrzeuge waypoint))
  ([n transports waypoint]
   (let [waypoint-coord [(:location/longitude waypoint)
                         (:location/latitude waypoint)]]
     (->> transports
          (sort (fn [transport-a transport-b]
                  (util/distance-sort waypoint-coord
                                      [(-> transport-a :transport/destination :location/longitude)
                                       (-> transport-a :transport/destination :location/latitude)]
                                      [(-> transport-b :transport/destination :location/longitude)
                                       (-> transport-b :transport/destination :location/latitude)])))
          vec
          (take n)))))

(defn sort-by-distance-to-origin [origin-coord location-coords]
  (vec (sort (partial util/distance-sort origin-coord) location-coords)))

(defn destination-coord [transport]
  [(-> transport :transport/destination :location/longitude)
   (-> transport :transport/destination :location/latitude)])

(defn origin-coord [transport]
  [(-> transport :transport/origin :location/longitude)
   (-> transport :transport/origin :location/latitude)])

(defn ->waypoint-coords [transports]
  (vec (set (map destination-coord transports))))

(defn sort-to [vec1 vec2]
  (vec (sort-by #(let [i (.indexOf vec1 %)]
                   (if (< i 0) (count vec1) i))
                vec2)))

(defn sort-by-distance [transports]
  (sort-by-distance-to-origin (origin-coord (first transports))
                              (->waypoint-coords transports)))

(defn sorted-route [transports]
  (if (and @!sort-by-distance? (seq transports))
    (sort-by-distance transports)
    (let [sorted @(deframe/!route-get ::sorted-route)]
      (cond->> (->waypoint-coords transports)
        sorted (sort-to sorted)))))

(comment
  @!selected-fahrzeuge
  (->waypoint-coords @(deframe/!route-get ::selected-fahrzeuge))
  (sorted-route @(deframe/!route-get ::selected-fahrzeuge)))

(defn fahrzeuge->load-id->transport-attrs
  "Pre-compute per-load transport attrs from vehicles for the v1 loads panel."
  [fahrzeuge]
  (->> fahrzeuge
       (filter :load/id)
       (group-by :load/id)
       (reduce-kv
        (fn [acc load-id vehicles]
          (let [vehicles (vec (sort-by :vehicle/vin vehicles))
                self-pickup? (contains? #{:self-pickup} (-> vehicles first :dispo/flag))
                origin (-> vehicles first :transport/origin)
                destinations (->> vehicles
                                  (map :transport/destination)
                                  (remove nil?)
                                  (reduce (fn [{:keys [seen ordered]} dest]
                                            (let [k [(:address/postcode dest)
                                                     (:address/city dest)
                                                     (:location/longitude dest)
                                                     (:location/latitude dest)]]
                                              (if (contains? seen k)
                                                {:seen seen :ordered ordered}
                                                {:seen (conj seen k)
                                                 :ordered (conj ordered dest)})))
                                          {:seen #{} :ordered []})
                                  :ordered)
                contract-names (->> vehicles
                                    (mapcat (fn [fahrzeug]
                                              (or (:contract/names fahrzeug)
                                                  (some-> fahrzeug :contract/name vector)
                                                  [])))
                                    set)]
            (assoc acc load-id
                   (cond-> {:self-pickup? self-pickup?
                            :waypoints (when-not self-pickup? destinations)}
                     origin (assoc :origin/location origin)
                     (seq contract-names) (assoc :transport/contract-names contract-names)))))
        {})))

(defn waypoints->summary
  "Format waypoints as a display string: 'City1 -> City2 -> ...'"
  [origin waypoints]
  (->> (concat (when origin [origin]) waypoints)
       (map (fn [wp] (:address/city wp)))
       (remove str/blank?)
       (str/join " -> ")))

(defn remove-transports [selected transports]
  (remove #(contains? (set (map :ductile/id transports)) (:ductile/id %))
          selected))

(defn toggle-transport [selected transport]
  (vec (if (contains? (set (map :ductile/id selected)) (:ductile/id transport))
         (remove-transports selected [transport])
         (conj selected transport))))

(defn set-sorted-route! [sorted-route]
  (tx! [[:op/assoc-in [:current-route/transient ::sorted-route] sorted-route]]))

(defn sort-route-tx [transports]
  [:op/assoc-in [:current-route/transient ::sorted-route] (sorted-route transports)])

(defn set-selected-fahrzeuge-tx [transports]
  [[:op/assoc-in [:current-route/transient ::selected-fahrzeuge] transports]])

(defn toggle-sort-by-distance! []
  (let [by-dist? (not @!sort-by-distance?)]
    (tx! (vec (cond-> [[:op/assoc-in [:current-route/transient ::sort-by-distance?] by-dist?]]
                by-dist?
                (concat [(sort-route-tx @!selected-fahrzeuge)]))))))

(defn remove-transports! [transports]
  (tx! (set-selected-fahrzeuge-tx (remove-transports @!selected-fahrzeuge transports))))

(defn toggle-transport! [transport]
  (perf-track-toggle-dispatch! transport)
  (tx! (set-selected-fahrzeuge-tx (toggle-transport @!selected-fahrzeuge transport))))

(defn confirm-removing-waypoint [waypoint]
  (let [close! #(tx! [[:op/dissoc-in [:current-route/transient ::transport/confirm-removing-waypoint]]])]
    [ui/alert {:open? true :on-close close!}
     [ui/alert-content
      [ui/alert-title
       (if (:waypoint/origin? waypoint)
         (tr "Are you sure you want to dismiss the entire load?")
         (tr "Are you sure you want to remove the entire stop in %1?" (str (:address/postcode waypoint) ui/nbsp (:address/city waypoint))))]
      [ui/alert-description
       [:div.mb-3 (tr "The following %1 vehicles will be removed from the load:" (count (:waypoint/transports waypoint)))]
       [transport/waypoint-vehicle-list (dissoc waypoint :waypoint/editable?)]]
      [:div {:class "flex justify-end gap-3"}
       [ui/alert-cancel
        [ui/button
         {:size 3 :on-click close!}
         (tr "Cancel")]]
       [ui/alert-action
        [ui/button
         {:variant :destructive
          :size 3
          :on-click #(let [ts (remove-transports @!selected-fahrzeuge (:waypoint/transports waypoint))]
                       (tx! (conj (set-selected-fahrzeuge-tx ts)
                                  [:op/dissoc-in [:current-route/transient ::transport/confirm-removing-waypoint]])))}
         (if (:waypoint/origin? waypoint)
           (tr "Dismiss entire load")
           (tr "Remove stop"))]]]]]))

(defn suggestions-view []
  (let [last-wp (last @!waypoints)
        selected-ids (set (map :ductile/id @!selected-fahrzeuge))]
    [:div
     [:div.px-3.py-1.bg-mauve3.border-t.border-b
      {:class "text-[11px]"}
      [:span.font-bold
       "💡 " (tr "Suggestions based on %1" (str (:address/postcode last-wp) " "
                                                (:address/city last-wp)))]]
     (map (fn [transport]
            ^{:key (str (:ductile/id transport))}
            [:div.bg-mauve2.px-3.py-2.text-xs.border-b.flex.gap-3.justify-between
             [:div
              [:div.text-xs.font-bold (str (-> transport :transport/destination :address/postcode) " "
                                           (-> transport :transport/destination :address/city))]
              [:div
               {:class "text-[11px]"} (-> transport :transport/destination :address/name)]
              [transport/waypoint-vehicle-list {:layout/size 1
                                                :waypoint/transports [transport]}]]
             [:div.flex.items-center
              [ui/button
               {:size 1
                :on-click #(toggle-transport! transport)}
               [ui/icon {:width 16 :height 16} :plus]]]])
          (suggestions-for-waypoint
           (remove #(selected-ids (:ductile/id %))
                   @(deframe/!route-get-in [:fetch :result :fahrzeuge]))
           (last @!waypoints)))]))

(defn stops-view
  ([load]
   [stops-view {:editable? true} load])
  ([{:keys [editable?]} load]
   (let [route-stops (group-by :transport/destination load)
         fetching-route? @(deframe/!route-get ::fetching-route?)]
     [:<>
      [:div
       (let [load-count (count load)
             stops-count (count route-stops)
             origin (assoc (-> load first :transport/origin) :waypoint/transports load)
             waypoint-views (map-indexed (fn [i waypoint]
                                           ^{:key (str "waypoint-" i)}
                                           [transport/route-waypoint (assoc waypoint
                                                                            :waypoint/remove-vehicle! #(remove-transports! [%])
                                                                            :waypoint/editable? true
                                                                            :waypoint/sortable? (not @!sort-by-distance?)
                                                                            :waypoint/index i
                                                                            :waypoint/details @(deframe/!route-get-in [::route :details i]))])
                                         @!waypoints)
             waypoints-without-coords (filter (fn [waypoint]
                                                (and (not (:location/longitude waypoint))
                                                     (not (:location/latitude waypoint))))
                                              @!waypoints)]
         [:div
          [:div.px-3.py-3
           [:div.text-xs.font-bold load-count " " (tr "Vehicles") " / " stops-count " " (tr "stops")]
           [:div.mt-1 {:class "text-[11px]"}
            (if fetching-route?
              (str (tr "Calculating route") "…")
              [transport/route-details @!route])
            (when (not-empty waypoints-without-coords)
              [:div.mt-1.text-red-600
               [:div.font-bold (tr "The following waypoints don’t have coordinates and won’t be displayed on the map") ":"]
               (into [:ul]
                     (map (fn [waypoint]
                            [:li.mt-1.flex.gap-1
                             [:div "⚠️"]
                             [:div.font-bold (str (:address/postcode waypoint) " " (:address/city waypoint))]]))
                     waypoints-without-coords)])]]
          (when editable?
            [:div.px-3.py-1.bg-mauve3.border-t.border-b
             [:label {:for :sort-by-distance
                      :class ["flex" "items-center" "gap-1" "text-[11px]"]}
              [:input {:type :checkbox
                       :checked @!sort-by-distance?
                       :on-change toggle-sort-by-distance!
                       :id :sort-by-distance}]
              "📐 "
              [:span {:class (when @!sort-by-distance? ["font-bold"])} (tr "Sort by distance")]]])
          [:<>
           [transport/route-waypoint (assoc origin :waypoint/editable? true :waypoint/origin? true)]
           (if @!sort-by-distance?
             (into [:div] waypoint-views)
             [ui/legacy-sortable
              {:handle ".sort-handle"
               :on-sort-update #(set-sorted-route! (util/vec-move @!sorted-route
                                                                  (.. % -detail -origin -index)
                                                                  (.. % -detail -destination -index)))}
              waypoint-views])
           [suggestions-view]]])]
      (when-let [waypoint @(deframe/!route-get ::transport/confirm-removing-waypoint)]
        [confirm-removing-waypoint waypoint])])))

(comment
  @!sorted-route)

(defn geocoded? [location]
  (and (number? (:location/longitude location))
       (number? (:location/latitude location))))

(defn address-code
  "Encode an address as a pipe-separated string.

  Mainly done this way so that when we put this as a filter value in the anchor
  the URL doesn't blow up too much."
  [{:address/keys [country postcode city street] :as addr}]
  ;; Bit messy here because we call this both with an address (qualified keys),
  ;; and with filters (not qualified)
  (let [country (:country addr country)
        postcode (:postcode addr postcode)
        city (:city addr city)
        street (:street addr street)]
    (when (and country postcode city street)
      (str (:country/code country) "|" postcode "|" city "|" street))))

(defn address-code->filters
  "Convert an address encoded as a pipe-separated string to a map that can be
  passed to our data filtering logic."
  [code]
  (let [[country postcode city street] (str/split code "|")]
    (when (and country postcode city street)
      {:country {:country/code country}
       :postcode postcode
       :city city
       :street street})))

(def addr-set
  (sorted-set-by
   (@#'fn->comparator #(compare (:address/name %1)
                                (:address/name %2)))))

(def transport-key
  "Given a transport entity, return a vector that uniquely identifies this transport."
  (juxt :vehicle/vin))

(defn address-string [{:address/keys [country postcode city]}]
  (str #_#_(:country/code country) "-" postcode " " city))

;; regenerate with `build.static-data/generate!(:load-builder)`
(defn fetch-data []
  (http/$get "https://storage.googleapis.com/ductile-data/snapshot-data/8VsqqHtF6P6VWszuLUVP8TAMUJNm4h3nqrJ5Dm6pULJBSAMiMMjYGayANyNR4fJW2GvV6B3dDRg8rfE7vBpQg2CzhQ"))

(def ordered-address-fields
  [:compound/name
   :address/name
   :address/postcode
   :address/city
   :address/street
   :address/region
   :address/province-code
   :address/country
   :location/latitude
   :location/longitude])

(def transports-table-schema
  [:fahrzeug/cardinal-direction
   :fahrzeug/parking-spot
   :fahrzeug/priority
   :fahrzeug/priorities
   :fahrzeug/expected-customer-delivery-datetime
   :fahrzeug/call-off-datetime
   :dispo/available-datetime
   :exit/expected-datetime
   :fahrzeug/labels
   :load/id
   [:transport/origin ordered-address-fields]
   [:transport/destination ordered-address-fields]
   :make/name
   :vehicle/model
   :contract/name
   :vehicle/weight
   :vehicle/vin])

(def table-head-viewer
  (assoc viewer/table-head-viewer
         :render-fn
         '(fn [header-row {:as opts :keys [path]}]
            (let [header-cells (nextjournal.clerk.viewer/desc->values header-row)
                  sub-headers (remove nil? (mapcat #(when (vector? %) (second %)) header-cells))]
              [:thead
               (into [:tr.print:border-b-2.print:border-black]
                     (map-indexed #(ductile.clerk.render/header-cell {:sub-headers? (seq sub-headers)
                                                                      :header-cell %2
                                                                      :opts opts
                                                                      :index %1}))
                     header-cells)
               (when-not (empty? sub-headers)
                 (into [:tr.print:border-b-2.print:border-black]
                       (map-indexed #(ductile.clerk.render/header-cell {:header-cell %2
                                                                        :opts opts
                                                                        :index %1}))
                       sub-headers))]))))

(def table-row-viewer
  (assoc viewer/table-row-viewer
         :render-fn
         '(fn [row {:as opts :keys [path number-col? toggle-selected! selected transports !expanded-at]}]
            (let [transport (transports (second path))
                  selected? (contains? (:selected @!expanded-at) transport)]
              (into [:tr.print:border-b-gray-500.print:hover:bg-transparent
                     {:class (str "print:border-b-[1px] "
                                  (if selected?
                                    "bg-amber-100 hover:bg-amber-200 "
                                    (str "hover:bg-indigo-50 "
                                         (if (even? (peek path)) "bg-white" "bg-slate-50"))))
                      :on-click (fn []
                                  (swap! !expanded-at update :selected (fnil (if selected? disj conj) #{}) transport)
                                  (toggle-selected! transport))}]
                    (map-indexed
                     (fn [idx cell]
                       [:td.px-4.py-2.text-sm.border-r.last:border-r-0
                        {:class (str "print:text-[10px] print:bg-transparent print:px-[5px] print:py-[2px] "
                                     (when (and (ifn? number-col?) (number-col? idx)) "text-right"))}
                        (nextjournal.clerk.render/inspect-presented opts cell)]))
                    row)))))

(def table-viewer
  (-> ductile.viewer/ductile-table-viewer
      (dissoc :page-size)
      (update :add-viewers viewer/add-viewers [table-head-viewer table-row-viewer])))

(defn dispatchable-fahrzeuge-clerk-table [transports filtered-transports]
  (let [transports       filtered-transports
        toggle-selected! toggle-transport!
        hidden-columns [:transport/origin :transport/destination :fahrzeug/expected-customer-delivery-datetime :contract/name]
        filter-paths {:destination/summary [:location/details :address/postcode]}
        make-filter (fn [k filter-set]
                      (fn [v]
                        (or (empty? filter-set)
                            (contains? filter-set (if-let [path (filter-paths k)] (get-in v path) v)))))
        row-filters {:destination/summary (make-filter [:destination/summary :location/details :address/postcode] #{})
                     :make/name (make-filter [:make/name] #{})
                     :vehicle/vin (make-filter [:vehicle/vin] #{})
                     :vehicle/model (make-filter [:vehicle/model] #{})}
        ;; TODO: Make prividing this better but not sure yet how as destination/summary is a computed column
        ;; and we don't want to recompute choices in each render
        filter-choices {:make/name (into (sorted-set) (map :make/name) transports)
                        :vehicle/vin (into (sorted-set) (map :vehicle/vin) transports)
                        :vehicle/model (into (sorted-set) (map :vehicle/model) transports)

                        :destination/summary (sort (into #{} (map #(get-in % [:transport/destination :address/postcode])) transports))}
        !opts (hooks/use-state {:schema transports-table-schema
                                :hide-columns hidden-columns
                                :column-order [:fahrzeug/cardinal-direction
                                               :fahrzeug/priority
                                               :fahrzeug/priorities
                                               :fahrzeug/expected-customer-delivery-datetime
                                               :origin/summary
                                               :destination/summary
                                               :make/name
                                               :vehicle/model
                                               :contract/name
                                               :vehicle/weight
                                               :vehicle/vin]
                                :hidden-paths (set (ductile.viewer/head->paths (ductile.viewer/expand-keys-to-head transports-table-schema hidden-columns)))
                                :translated-keys {:fahrzeug/cardinal-direction (tr "Direction")
                                                  :origin/summary (tr "Origin")
                                                  :destination/summary (tr "Destination")
                                                  :fahrzeug/priorities (tr "Binding")}
                                :row-filters row-filters})]
    [:> context-menu/Root
     [:> context-menu/Trigger
      [:div.transports-table
       [render/inspect
        (viewer/table
         {:nextjournal.clerk/viewers
          (viewer/add-viewers [table-viewer])
          :nextjournal.clerk/render-opts
          (merge {:toggle-selected! toggle-selected!
                  :update-filters! (fn [k filter-set]
                                     (swap! !opts assoc-in [:row-filters k] (make-filter k filter-set)))
                  :transports (vec transports)
                  :filter-choices filter-choices
                  :column-widths {:origin/summary 150
                                  :vehicle/vin 190
                                  :make/name 100
                                  :fahrzeug/priority 105
                                  :fahrzeug/cardinal-direction 80
                                  :fahrzeug/priorities 60}
                  :computed-columns {:fahrzeug/cardinal-direction (fn [{:transport/keys [origin destination]}]
                                                                    {:cardinal-direction/from origin :cardinal-direction/to destination})
                                     :fahrzeug/priority (fn [{date :fahrzeug/expected-customer-delivery-datetime}]
                                                          {:priority/date date})
                                     :origin/summary (fn [{orig :transport/origin}]
                                                       {:location/summary (str (:address/postcode orig) " "
                                                                               (:address/city orig))
                                                        :location/details orig})
                                     :destination/summary (fn [{dest :transport/destination}]
                                                            {:location/summary (str (:address/postcode dest) " "
                                                                                    (:address/city dest))
                                                             :location/details dest})}}
                 @!opts)}
         transports)]]]
     [:> context-menu/Portal
      [:> context-menu/Content
       [ductile.render/context-menu !opts]]]]))

(defn show-success-toast-tx [transport]
  ;; TODO: restore old :use-existing behaviour
  [[:op/assoc :toast {:title (str "✅ " (if (= :use-existing (:action transport))
                                         (tr "Vehicles were successfully added")
                                         (tr "Transport successfully created")))
                      :description (tr "Click here to show the modified transport.")
                      :action {:as :a
                               :href (transport/transport-link transport)
                               :variant :success
                               :data-testid "transport-created-toast-action"
                               :label (str "🚛 " (tr "Show transport"))}
                      :variant :success}]])

(defn $assign-exit-transport [load selected-fahrzeuge]
  (-> (http/$lambda 'ductile.transport/handle-assign-exit-transport
                    (merge load
                           (deframe/current-route-params)
                           {:destination/ductile-ids (mapv :ductile/id @!waypoints)
                            :vehicle-search-params {:search-params {:ductile/id (into #{} (map :ductile/id) selected-fahrzeuge)}}}))
      (.then (fn [result]
               (if (:error result)
                 (tx! [[:op/assoc-in [:current-route/transient :fetch :error] result]])
                 (do
                   (tx! (into [[:op/dissoc-in [:current-route/transient ::selected-fahrzeuge]]
                               [:op/dissoc-in [:current-route/transient ::transport/edit-transport]]
                               [:op/dissoc-in [:current-route/transient :fetch :error]]
                               fields/reset-current-load]
                              (show-success-toast-tx result)))
                   (deframe/route-refetch!)))))))

(defn edit-load-header [load]
  (hooks/use-effect fields/ensure-trucks-and-carriers!)
  (let [{load-id :load/id :transport/keys [transporter carrier]} load
        transporter-or-carrier (fields/transporter-or-carrier {:trucks @fields/!trucks :carriers @fields/!carriers}
                                                              (or transporter carrier))]
    [:div
     [:div.font-bold (if load-id (tr "Update %1" load-id) (tr "Create new load"))]
     (when load-id
       [:div.text-xs
        (if transporter
          (fields/transporter-summary transporter-or-carrier)
          (fields/carrier-summary transporter-or-carrier))])]))


(defn vins->filter [vins]
  (try
    {:vins vins
     :filter.omnibox/type :filter.omnibox.type/glob
     :filter.omnibox/tooltip (str/join "\n" vins)
     :filter.omnibox/regex (js/RegExp. (str/join "|" (map omnibox/normalize vins)))}
    (catch :default _e nil)))

(defn mark-matched [all-values filter-values filter]
  (->> filter-values
       (map (fn [filter-value]
              {:matched? (some #(omnibox/matches-filter? (omnibox/normalize %)
                                                         {:filter.omnibox/type :filter.omnibox.type/substring
                                                          :filter.omnibox/normalized-value (omnibox/normalize filter-value)}) all-values)
               :value filter-value}))
       seq))

(defn vins-string->filter [filtered-transports]
  (fn [vins-string]
    (when-let [vins (re-seq #"\b[A-Z0-9]{3,17}\b" vins-string)]
      (when (<= 2 (count vins))
        (let [vins-filter (vins->filter vins)
              non-matching-count (->> (mark-matched (map :vehicle/vin filtered-transports) (:vins vins-filter) vins-filter)
                                      (remove :matched?)
                                      count)]
          (assoc vins-filter
                 :on {:click [[:store/route-assoc ::vins-filter-modal vins]]}
                 :filter.omnibox/custom-label [:div.group.font-normal.cursor-pointer.font-sans ; needs to be serializable to localstorage, can't use ui components here
                                               [:span.font-bold (str (count vins) " " (tr "VINs"))]
                                               (when non-matching-count
                                                 [:div.opacity-90.leading-tight {:class "text-[11px]"}
                                                  "⚠️ " (tr "%1 VINs not found" non-matching-count)])]))))))

(defn vins-filter-modal [vins filtered-transports]
  [:div
   (let [vins-filter (vins->filter vins)
         marked-vins (mark-matched (map :vehicle/vin filtered-transports) vins vins-filter)
         non-matching-count (->> marked-vins (remove :matched?) count)]
     [:div

      [:div.text-lg.font-bold.p-3 (count vins) " " (tr "VINs")
       (when (pos? non-matching-count)
         [:span.text-orange-400 " (" (tr "%1 VINs not found" non-matching-count) ")"])]



      [:div.px-4.pb-2
       [:table
        (for [{:keys [value matched?]} marked-vins]
          ^{:key value}
          [:tr
           [:td.p-1.select-none (when-not matched? " ⚠️")]
           [:td.p-1.w-full {:class (when-not matched? "text-orange-700")} [ui/vin value]]])]]])])

(defn dispatchable-fahrzeuge-react-table [transports visible-transports filter-choice-transports]
  (let [!expanded-at (hooks/use-state {})
        ;; TODO: Make providing this better but not sure yet how as destination/summary is a computed column
        ;; and we don't want to recompute choices in each render
        local-storage-key "load-builder-table-opts"
        col-settings @(deframe/!localstorage-get :ductile.ui.load-builder/dispatchable-vehicles-col-settings)
        hide-columns [[:transport/origin (vec (remove #{:address/postcode :address/city} ordered-address-fields))]
                      [:transport/destination (vec (remove #{:address/postcode :address/city} ordered-address-fields))]
                      :fahrzeug/expected-customer-delivery-datetime
                      :fahrzeug/call-off-datetime
                      :exit/expected-datetime
                      :load/id
                      :fahrzeug/parking-spot]
        column-order [:vehicle/vin
                      :fahrzeug/cardinal-direction
                      :fahrzeug/priority
                      :fahrzeug/priorities
                      :fahrzeug/labels
                      :fahrzeug/expected-customer-delivery-datetime
                      :fahrzeug/call-off-datetime
                      :dispo/available-datetime
                      :exit/expected-datetime
                      :load/id
                      [:transport/origin ordered-address-fields]
                      [:transport/destination ordered-address-fields]
                      :make/name
                      :vehicle/model
                      :contract/name
                      :vehicle/weight
                      :fahrzeug/parking-spot]
        available-cols (into (set hide-columns) column-order)
        !opts (hooks/use-state (merge
                                {:schema transports-table-schema
                                 :row-action (fn [transport]
                                               (when (str/blank? (.. js/document getSelection toString))
                                                 (perf-track-click! transport)
                                                 (toggle-transport! transport)))
                                 :hide-columns hide-columns
                                 :column-order column-order
                                 :translated-keys {:fahrzeug/cardinal-direction (tr "Direction")
                                                   :fahrzeug/parking-spot (tr "Parking spot")
                                                   :fahrzeug/priority (tr "Priority")
                                                   :fahrzeug/priorities (tr "Binding")
                                                   :transport/origin (tr "Origin")
                                                   :compound/name (tr "Compound")
                                                   :location/latitude (tr "Latitude")
                                                   :location/longitude (tr "Longitude")
                                                   :address/country (tr "Country")
                                                   :address/city (tr "City")
                                                   :address/postcode (tr "Postcode")
                                                   :address/street (tr "Street")
                                                   :address/name (tr "Address name")
                                                   :transport/destination (tr "Destination")
                                                   :load/id (tr "Load ID")
                                                   :make/name (tr "Make")
                                                   :vehicle/weight (tr "Weight")
                                                   :vehicle/model (tr "Model")
                                                   :contract/name (tr "Contract")
                                                   :fahrzeug/labels (tr "Labels")}
                                 :column-layout {:fahrzeug/cardinal-direction {:min-width 106}
                                                 :fahrzeug/priority {:min-width 106}
                                                 :fahrzeug/priorities {:min-width 97}
                                                 :fahrzeug/labels {:min-width 90}
                                                 :fahrzeug/expected-customer-delivery-datetime {:min-width 150}
                                                 [:transport/origin :address/postcode] {:min-width 114}
                                                 [:transport/origin :address/city] {:min-width 140}
                                                 [:transport/destination :address/postcode] {:min-width 114}
                                                 [:transport/destination :address/city] {:min-width 255}
                                                 :vehicle/vin {:min-width 190}
                                                 :make/name {:min-width 100}
                                                 :load/id {:min-width 100}
                                                 :fahrzeug/parking-spot {:min-width 116}}
                                 :transform-columns
                                 {[:transport/origin :address/postcode]
                                  (fn [{orig :transport/origin}]
                                    (when (and orig (:address/postcode orig))
                                      {:location/summary (:address/postcode orig)
                                       :location/details orig
                                       :viewer/css-class "tabular-nums text-right"}))

                                  [:transport/destination :address/postcode]
                                  (fn [{dest :transport/destination}]
                                    (when (and dest (:address/postcode dest))
                                      {:location/summary (:address/postcode dest)
                                       :location/details dest
                                       :viewer/css-class "tabular-nums text-right"}))

                                  [:fahrzeug/labels]
                                  (fn [{labels :fahrzeug/labels}]
                                    (when (seq labels) {:labels labels}))

                                  [:fahrzeug/expected-customer-delivery-datetime]
                                  (fn [transport]
                                    {:format :date
                                     :style :short
                                     :locale (locale/get-current-locale)
                                     :instant (:fahrzeug/expected-customer-delivery-datetime transport)})

                                  [:dispo/available-datetime]
                                  (fn [transport]
                                    {:format :date
                                     :style :short
                                     :locale (locale/get-current-locale)
                                     :instant (:dispo/available-datetime transport)})

                                  [:exit/expected-datetime]
                                  (fn [transport]
                                    {:format :date
                                     :style :short
                                     :locale (locale/get-current-locale)
                                     :instant (:exit/expected-datetime transport)})

                                  [:fahrzeug/call-off-datetime]
                                  (fn [transport]
                                    {:format :date
                                     :style :short
                                     :locale (locale/get-current-locale)
                                     :instant (:fahrzeug/call-off-datetime transport)})

                                  [:vehicle/vin]
                                  (ductile.viewer/tabular-viewer [:vehicle/vin] {:font :mono})}
                                 :computed-columns {:fahrzeug/cardinal-direction (fn [{:transport/keys [origin destination]}]
                                                                                   (when (and origin destination)
                                                                                     {:cardinal-direction/from origin :cardinal-direction/to destination}))
                                                    :fahrzeug/priority (fn [{date :fahrzeug/expected-customer-delivery-datetime}]
                                                                         (when date
                                                                           {:priority/date date}))}}
                                (localstorage/get-item local-storage-key)))
        opts (merge @!opts
                    (columns/->table-opts {:col-settings col-settings
                                           :available-cols available-cols
                                           :default-selected-cols column-order}))
        filter-specs [[:make/name {}]
                      [[:transport/origin :address/postcode] {:numeric? true}]
                      [[:transport/origin :address/city] {}]
                      [[:transport/origin :address/name] {}]
                      [[:transport/destination :address/postcode] {:numeric? true}]
                      [[:transport/destination :address/region] {}]
                      [[:transport/destination :address/province-code] {}]
                      [[:transport/destination :address/city] {}]
                      [[:transport/destination :address/name] {}]
                      [:fahrzeug/expected-customer-delivery-datetime {:date? true}]
                      [:dispo/available-datetime {:date? true}]
                      [:exit/expected-datetime {:date? true}]
                      [:vehicle/model {}]
                      [:contract/name {}]
                      [:vehicle/weight {:numeric? true}]
                      [:load/id {}]
                      [:fahrzeug/parking-spot {}]
                      [:fahrzeug/labels {:set? true}]
                      [:vehicle/vin {:font :mono
                                     :text->filter (vins-string->filter visible-transports)}]]
        table-filters (hooks/use-memo
                       #(into {:fahrzeug/priorities [:checkbox "🤝"]}
                              (for [[k filter-opts] filter-specs]
                                (let [extract-value (if (vector? k)
                                                      (fn [row] (get-in row k))
                                                      (fn [row] (get row k)))]
                                  [k [:omnibox
                                      (cond
                                        (:set? filter-opts) (apply set/union (map extract-value filter-choice-transports))
                                        (:date? filter-opts) (into (sorted-set)
                                                                   (map omnibox/date->day)
                                                                   (map extract-value filter-choice-transports))
                                        :else (into (sorted-set)
                                                    (map extract-value)
                                                    filter-choice-transports))
                                      filter-opts]])))
                       [filter-choice-transports visible-transports])]
    [:<>
     [:div.w-full.h-full.flex.flex-col.overflow-hidden
      [:div.transports-table.split-table.overflow-auto.shadow-sm.rounded.border.border-slate-300.w-full
       [table/table
        (merge {:row-key           :ductile/id
                :row-testid-fn (fn [row] (str "table-row-" (:vehicle/vin row)))
                :!expanded-at      !expanded-at
                :virtualize-rows? true
                :virtual-scroll-container-selector ".transports-table"
                :virtual-row-height 30
                :virtual-overscan 8
                :update-filters!   (fn [k filter selected]
                                     (tx! [[:op/assoc-in [:current-route/transient ::filters (if (vector? k) k [k])] selected]]))
                :filters table-filters
                :transports (vec transports)}
               opts)
        transports]]
      (when-not (empty? @!selected-fahrzeuge)
        (let [load @fields/!current-load]
          [:<>
           [:div.mt-3.split-table.bg-slate-100.rounded-t.border.border-b-0.border-slate-300.shadow-sm.px-3.py-2.flex-shrink-0.flex.items-center.justify-between
            {:data-testid "editing-load-pane"}
            [:div.flex.items-center.gap-3
             (if (:load/id load)
               [ui/tooltip
                {:content (tr "Delete load")}
                [:div
                 [ui/button
                  {:size 1
                   :variant :destructive
                   :on-click #(when (js/confirm (tr "Are you sure you want to delete load %1?" (:load/id load)))
                                (-> (http/$lambda 'ductile.transport/handle-delete-transport {:ductile/id (:ductile/id load)})
                                    (.then (fn [result]
                                             (if (:error result)
                                               (tx! [[:op/assoc-in [:current-route/transient :fetch :error] result]])
                                               (do
                                                 (tx! [[:op/dissoc-in [:current-route/transient ::selected-fahrzeuge]]
                                                       [:op/dissoc-in [:current-route/transient :selected-load]]
                                                       [:op/dissoc-in [:current-route/transient ::transport/edit-transport]]
                                                       [:op/dissoc-in [:current-route/transient :fetch :error]]
                                                       fields/reset-current-load
                                                       [:op/assoc :toast {:title (str "✅ " (tr "Load was successfully deleted"))
                                                                          :variant :success}]])
                                                 (deframe/route-refetch!)))))))}
                  [ui/icon {:size 16} :trash]]]]
               [ui/tooltip
                {:content (tr "Dismiss load")}
                [:div
                 [ui/button
                  {:variant :destructive
                   :size 1
                   :on-click (fn dismiss-create-load []
                               (when (js/confirm (tr "This load has not been saved yet. Are you sure you want to dismiss it?"))
                                 (fields/set-current-load! nil)
                                 (tx! (set-selected-fahrzeuge-tx []))
                                 (tx! [[:op/dissoc-in [:current-route/transient :fetch :error]]])))}
                  [ui/icon {:size 16} :trash]]]])
             [edit-load-header load]]
            [:div.flex.items-center.gap-2
             (when (and (:load/id load) (-> load :transport/available-actions :transport/can-be-finalized?))
               [ui/tooltip {:content (if (:transport/finalized-at load)
                                       (tr "Mark the load as not finalized")
                                       (tr "Mark the load as finalized"))}
                [:div
                 [ui/button
                  {:variant :secondary
                   :size 1
                   :data-testid "toggle-finalized"
                   :on-click (fn toggle-finalized []
                               (-> (http/$lambda 'ductile.transport/toggle-finalized!
                                                 (merge load
                                                        (deframe/current-route-params)))
                                   (.then (fn [result]
                                            (if (:error result)
                                              (tx! [[:op/assoc-in [:current-route/transient :fetch :error] result]])
                                              (do
                                                (fields/set-current-load! nil)
                                                (tx! (set-selected-fahrzeuge-tx []))
                                                (tx! (into [[:op/dissoc-in [:current-route/transient :fetch :error]]
                                                            fields/reset-current-load
                                                            [:op/assoc :toast {:title (str "✅ " (if (:transport/finalized-at load)
                                                                                                  (tr "Load successfully marked as not finalized")
                                                                                                  (tr "Load successfully marked as finalized")))
                                                                               :variant :success}]]))

                                                (deframe/route-refetch!)))))))}
                  [ui/icon {:size 16}
                   (if (:transport/finalized-at load)
                     :lock
                     :unlock)]]]])
             [ui/tooltip
              {:content (tr "Confirm load")}
              [:div
               [ui/button
                {:variant :primary
                 :size 1
                 :data-testid "confirm-load"
                 :on-click (fn save-create-load []
                             (deframe/route-assoc! ::transport/edit-transport true))}
                [ui/icon {:size 16} :check]]]]
             (when (:load/id load)
               [ui/tooltip
                {:content (tr "Don’t update")}
                [:div
                 [ui/button
                  {:variant :secondary
                   :size 1
                   :on-click (fn dismiss-update-load []
                               (fields/set-current-load! nil)
                               (tx! (set-selected-fahrzeuge-tx []))
                               (tx! [[:op/dissoc-in [:current-route/transient :fetch :error]]
                                     [:op/dissoc-in [:current-route/transient :selected-load]]]))}
                  [ui/icon {:size 16} :cross-2]]]])]
            #_#_(when-let [error @(deframe/!route-get-in [:fetch :error])]
                  [:div.overflow-x-auto.p-2.bg-red-50.rounded-md.border.border-red-400.mb-2.flex-shrink-0
                   [ui/expected-error-view error]])
              [:div.text-xs.flex.flex-wrap.gap-2
               [fields/transport-form
                {:on-submit (fn [load] ($assign-exit-transport load @!selected-fahrzeuge))
                 :fixed-params {:transport/mode :mode/truck}
                 :submit-button-class ["mt-[21px]"]
                 :show-debug-output? (ui/debug-mode?)}]]]
           [:div.flex-shrink-0.split-table.overflow-auto.shadow-sm.rounded-b.border.border-slate-300
            [table/table
             (assoc opts :hide-head? true :sticky-cols-count 0)
             @!selected-fahrzeuge]]]))]
     (when-let [vins @(deframe/!route-get ::vins-filter-modal)]
       [ui/modal {:open? true :on {:close [[:store/route-assoc ::vins-filter-modal]]}}
        [vins-filter-modal vins visible-transports]])

     (when @(deframe/!route-get ::dispatchable-vehicles-col-settings-modal?)
       [columns/select-columns-modal
        {:col-settings col-settings
         :available-cols available-cols
         :default-selected-cols column-order
         :on-close #(deframe/route-dissoc! ::dispatchable-vehicles-col-settings-modal?)
         :on-change (fn [new-col-settings]
                      (deframe/localstorage-assoc! :ductile.ui.load-builder/dispatchable-vehicles-col-settings new-col-settings)
                      (deframe/route-dissoc! ::dispatchable-vehicles-col-settings-modal?))}])

     (when @(deframe/!route-get ::transport/edit-transport)
       [fields/edit-transport-dialog
        {:on-submit (fn [load] ($assign-exit-transport load @!selected-fahrzeuge))
         :fixed-params {:transport/mode :mode/truck}
         :customer-names (set (map :customer/name @!selected-fahrzeuge))
         :available-actions @(deframe/!route-get-in [:fetch :result :available-actions] {})
         :show-debug-output? (ui/debug-mode?)
         :on-close #(tx! [[:op/dissoc-in [:current-route/transient ::transport/edit-transport]]
                          [:op/dissoc-in [:current-route/transient :fetch :error]]])}])]))

(defn loads-view [selected-fahrzeuge]
  [:div.rounded.border.border-slate-300.shadow-sm.bg-white.flex.flex-col.flex-auto.overflow-auto
   {:data-testid "create-tour-panel"}
   [:div.min-w-fit
    [:div.bg-slate-100.px-3.py-2.font-bold.flex.items-center.justify-between.border-b.border-slate-300 (tr "Waypoints")]
    [stops-view {:editable? true} selected-fahrzeuge]]])

(defn within-bounds? [bounds {:as transport :transport/keys [origin destination]}]
  (let [{:location/keys [longitude latitude]} destination]
    (if (and longitude latitude)
      (turf/booleanWithin
       (turf/point #js[longitude latitude])
       (turf/bboxPolygon (into-array bounds)))
      true)))

(defn within-clusters? [clusters {:as transport :transport/keys [destination]}]
  (contains? (apply set/union (map :postcodes clusters)) (:address/postcode destination)))

(defn filter-fahrzeuge
  ([pan-to-filter? filters fahrzeuge]
   (filter-fahrzeuge pan-to-filter? filters fahrzeuge {:exclude-selected? true
                                                       :show-fahrzeuge-on-loads? false}))
  ([pan-to-filter? filters fahrzeuge {:keys [exclude-selected? show-fahrzeuge-on-loads? selected-ids]
                                      :or {exclude-selected? true
                                           show-fahrzeuge-on-loads? false
                                           selected-ids (into #{} (map :ductile/id) @!selected-fahrzeuge)}}]
   (let [filter-fns (->> filters
                         (keep (fn [[path filter-val]]
                                 (cond
                                   (= path :bounds)
                                   (when pan-to-filter?
                                     (partial within-bounds? filter-val))

                                   (= path :clusters)
                                   (partial within-clusters? filter-val)

                                   (= path [:fahrzeug/priorities])
                                   (when filter-val
                                     #(util/index-of :prioritiy/binding-customer-appointment (:fahrzeug/priorities %)))

                                   (= path [:fahrzeug/labels])
                                   (fn [%]
                                     (let [exact-filter-val (set (filter (comp #{:filter.omnibox.type/exact} :filter.omnibox/type)
                                                                         filter-val))
                                           substr-filter-val (set (filter (comp #{:filter.omnibox.type/substring} :filter.omnibox/type)
                                                                          filter-val))]
                                       (cond
                                         (seq exact-filter-val)
                                         (some #(omnibox/matches? % exact-filter-val)
                                               (get-in % path))

                                         (seq substr-filter-val)
                                         (omnibox/matches? (map tr (get-in % path)) substr-filter-val)

                                         (and (empty? exact-filter-val)
                                              (empty? substr-filter-val))
                                         true)))

                                   (= :filter/omnibox (:filter (meta filter-val)))
                                   #(omnibox/matches? (get-in % path) filter-val)

                                   :else
                                   (when-not (empty? filter-val)
                                     #(contains? filter-val (get-in % path)))))))]

     (cond->> fahrzeuge
       exclude-selected?
       (remove (comp selected-ids :ductile/id))

       (not show-fahrzeuge-on-loads?)
       (remove :load/id)

       (not-empty filter-fns)
       (filterv (apply every-pred filter-fns))))))

(def waypoints-panel-width 400)

(defn resize-x-by! [dx]
  (let [table-el (js/document.getElementById "load-builder-table")
        layout-el (js/document.getElementById "load-builder-layout")
        map-el (js/document.getElementById "load-builder-map")
        resizer-el (js/document.getElementById "load-builder-resizer")
        table-width (* 100 (/ (- (.-offsetWidth table-el) dx)
                              (.-offsetWidth layout-el)))]
    (when (<= 5 table-width 100)
      (set! (.. table-el -style -width) (str table-width "%"))
      (when map-el (set! (.. map-el -style -width) (str (- 100 table-width) "%")))
      (when resizer-el (set! (.. resizer-el -style -left) (str (- 100 table-width) "%")))
      (.forEach (js/document.querySelectorAll ".split-table")
                (fn [el]
                  (set! (.. el -style -width)
                        (str (- (.-offsetWidth table-el)
                                (if (js/document.querySelector ".staging-panel") waypoints-panel-width 20)) "px")))))))

(defn resize-y-by! [dy]
  (when-let [transports-table-el (js/document.getElementById "load-builder-transports-table")]
    (let [layout-el (js/document.getElementById "load-builder-layout")
          y-resizer-el (js/document.getElementById "load-builder-transports-resizer")
          transports-table-height (* 100 (/ (- (.-offsetHeight transports-table-el) dy)
                                            (.-offsetHeight layout-el)))]
      (when (<= 5 transports-table-height 95)
        (deframe/localstorage-assoc! ::transports-height transports-table-height)
        (set! (.. y-resizer-el -style -bottom) (str transports-table-height "%"))
        (set! (.. transports-table-el -style -height) (str transports-table-height "%"))))))


(defn add-cluster-filter! [id postcodes]
  (let [filters            @!filters
        {:keys [clusters]} filters
        postcodes          (set postcodes)
        clusters'          (if (seq clusters)
                             (conj clusters {:postcodes postcodes :id id})
                             (set [{:postcodes postcodes :id id}]))
        filters'           (assoc filters :clusters clusters')]
    (tx! [[:op/assoc-in [:current-route/transient ::filters] filters']])))

(defn on-marker-clicked [^js the-map event]
  (let [features (.queryRenderedFeatures the-map (.-point event) (j/lit {:layers ["unclusteredLocationsDelivery"]}))
        id (j/get-in features [0 :properties :id])
        new-selected-marker-ids (conj (or @!selected-marker-ids #{}) id)]
    (add-cluster-filter! id [(j/get-in features [0 :properties :postcode])])
    (tx! [[:op/assoc-in [:current-route/transient ::selected-marker-ids] new-selected-marker-ids]])
    (.setLayoutProperty the-map "unclusteredLocationsDelivery" "icon-image"
                        (j/lit ["match" ["get" "id"] id
                                "unclustered-delivery-selected-n"
                                (overview-map/selected-markers-condition new-selected-marker-ids)]))))

(defn on-cluster-clicked [^js the-map event]
  (let [features (.queryRenderedFeatures the-map (.-point event) (j/lit {:layers ["locationClustersDelivery"]}))
        cluster-id (j/get-in features [0 :properties :cluster_id])
        point-count (j/get-in features [0 :properties :point_count])]
    (.. the-map
        (getSource "locationClusters")
        (getClusterLeaves cluster-id point-count 0 (fn [err features]
                                                     (when-not err
                                                       (add-cluster-filter! cluster-id (map #(j/get-in % [:properties :postcode]) features))))))
    (.setFeatureState the-map
                      (j/lit {:source "locationClusters" :id cluster-id})
                      (j/lit {:selected true}))))


(defn ^:export vinOnMap [vin]
  (let [fzg (->> @(deframe/!route-get-in [:fetch :result :fahrzeuge])
                 (filter (comp #{vin} :vehicle/vin))
                 first)
        ^js location (-> fzg
                         :transport/destination
                         (set/rename-keys {:location/latitude :lat :location/longitude :lon})
                         (select-keys #{:lat :lon})
                         clj->js)
        ^js xy (.project @overview-map/!the-map location)]
    (j/lit {:position {:x (.-x xy) :y (.-y xy)}})))

(def dropdown-menu-styles
  transport/dropdown-menu-styles)

(defn legend [theme]
  [:div.flex.gap-6.items-center.text-xs.px-3.shrink-0 {:style {:height 30}}
   [:div.text-gray-600.flex.items-center
    [:div.rounded-full.relative
     {:style {:border (str "2px solid " (get-in theme [:vis "pickup"]))
              :width 15 :height 15}}
     [:div.w-full.h-full.rounded-full
      {:style {:background (get-in theme [:vis "pickup"]) :opacity 0.2}}]]
    [:span.ml-1
     {:style {:color (get-in theme [:vis "pickup"])}} (tr "Origin")]
    [:span.font-bold.mx-2
     {:style {:font-size 15}}
     [ui/icon :arrow-right]]
    [:div.rounded-full.relative
     {:style {:border (str "2px solid " (get-in theme [:vis "delivery"]))
              :width 15 :height 15}}
     [:div.w-full.h-full.rounded-full
      {:style {:background (get-in theme [:vis "delivery"]) :opacity 0.2}}]]
    [:span.ml-1
     {:style {:color (get-in theme [:vis "delivery"])}} (tr "Destination")]]])

(def !selected-load (deframe/!route-get :selected-load))

(defn transports-table [loads]
  [transport/transports-table
   {:transports loads
    :schema (conj transport/table-schema :actions)
    :transform-columns {[:transport/name]
                        (fn [transport]
                          [:a (:transport/name transport)])
                        [:transport/status]
                        (fn [transport]
                          [:a {:data-testid (str "status-" (:load/id transport))}
                           (ui/transport-status-badge (:transport/status transport))])
                        [:load/id]
                        (fn [transport]
                          [:a {:data-testid (str "load-id-" (:load/id transport))}
                           (:load/id transport)])
                        [:transport/waypoints]
                        (fn [transport]
                          (if (transport/self-pickup? transport)
                            {:labels [:self-pickup]}
                            (let [summary (waypoints->summary (:origin/location transport) (:waypoints transport))]
                              [:span {:class "text-xs truncate"
                                      :title summary
                                      :style {:max-width 300}}
                               summary])))}
    :selected-rows (when-let [selected-load @!selected-load]
                     [selected-load])
    :actions (fn [transport]
               [:<>
                [:a.text-indigo-600.hover:underline
                 {:class "text-[11px]"
                  :target "_blank"
                  :href (routes/path (cond-> '[loads :ductile/id summary])
                                     {:ductile/id (:ductile/id transport)})}
                 (tr "Load summary")]])
    :row-action (fn [load]
                  (let [fahrzeuge @(deframe/!route-get-in [:fetch :result :fahrzeuge])]
                    (tx! [[:op/assoc-in [:current-route/transient :selected-load] load]])
                    (fields/set-current-load! load)
                    (tx! (set-selected-fahrzeuge-tx (filterv (comp #{(:load/id load)}
                                                                   :load/id)
                                                             fahrzeuge)))))}])


(defn settings-menu [{:keys [show-fahrzeuge-on-transports?
                             show-fahrzeuge-on-transports-storage-key]
                      :as opts}]
  [:div.flex.gap-2.items-center
   [ui/dropdown
    {:button [:button.text-gray-600.hover:text-gray-700.active:text-gray-800.flex.items-center.gap-1
              [ui/icon :gear]
              [:span.flex.items-center
               {:data-testid "load-builder-settings"}
               (tr "Settings")
               [ui/icon :caret-down]]]
     :items [:div.flex.flex-col.items-stretch.min-w-64
             [ui/localstorage-toggle {:data-testid "show-flows"} (tr "Show flows") @!show-flows? ::show-flows?]
             [ui/localstorage-toggle {:data-testid "show-map"} (tr "Show map") @!show-map? ::show-map?]
             [ui/localstorage-toggle {:data-testid "show-loads"} (tr "Show loads") @!show-loads? ::show-loads?]
             [ui/localstorage-toggle {:data-testid "show-fahrzeuge-on-loads"}
              (tr "Show vehicles on transports")
              show-fahrzeuge-on-transports?
              show-fahrzeuge-on-transports-storage-key]
             [ui/localstorage-toggle {:data-testid "show-waypoints"} (tr "Show waypoints") @!show-waypoints? ::show-waypoints?]
             [ui/localstorage-toggle {:data-testid "pan-to-filter"} (tr "Use current map viewport as filter") @!pan-to-filter? ::pan-to-filter?]
             [ui/localstorage-toggle {:on-click #(if (http/speculative-transactions?)
                                                   (http/$disable-speculative-transactions!)
                                                   (-> (http/$lambda 'ductile.elog.tx-import/speculative-fahrzeug-import
                                                                     {:scan/result "WBY31AW0X0FS95482"
                                                                      :compound-name "Krefeld"})
                                                       (.then (fn [{:as lambda-response :keys [speculative-opts error]}]
                                                                (if error
                                                                  (tx! [[:op/assoc-in [:current-route/transient ::state :error] lambda-response]])
                                                                  (do (http/set-speculative-transaction-opts! (assoc speculative-opts :skip-localstorage true))
                                                                      (deframe/route-refetch!)))))))}
              (tr "Use temporary ELOG import")
              (http/speculative-transactions?)]]}]
   [columns/select-profile-dropdown opts]])

(defn dispatchable-car-tasks [{:as params :keys [fahrzeuge]}]
  ;; TODO: rename args transports -> fahrzeuge
  ;; TODO: incorporate in the main fetch
  (reagent/with-let [table-width 65]
    (let [{:keys [storage-key default?]} (show-fahrzeuge-on-transports-setting)
          show-map? @!show-map?
          show-loads? @!show-loads?
          show-waypoints? @!show-waypoints?
          show-fahrzeuge-on-loads? @(deframe/!localstorage-get storage-key default?)
          transports-height (if show-loads? @!transports-height 0)
          show-flows?         @!show-flows?
          pan-to-filter?      @!pan-to-filter?
          clerk-table?        @!clerk-table?
          ^js the-map         @overview-map/!the-map
          selected-fahrzeuge  @!selected-fahrzeuge
          !deferred-selected-fahrzeuge (hooks/use-state selected-fahrzeuge)
          selected-ids        (hooks/use-memo #(into #{} (map :ductile/id) selected-fahrzeuge) [selected-fahrzeuge])
          filters             @!filters
          raw-loads           (:loads @(deframe/!route-get-in [:fetch :result] {}))
          base-filtered-fahrzeuge (hooks/use-memo #(filter-fahrzeuge pan-to-filter? filters fahrzeuge
                                                                     {:exclude-selected? false
                                                                      :show-fahrzeuge-on-loads? show-fahrzeuge-on-loads?})
                                                  [pan-to-filter? filters fahrzeuge show-fahrzeuge-on-loads?])
          filtered-fahrzeuge  (hooks/use-memo #(if (empty? selected-ids)
                                                 base-filtered-fahrzeuge
                                                 (filterv (comp (complement selected-ids) :ductile/id)
                                                          base-filtered-fahrzeuge))
                                              [base-filtered-fahrzeuge selected-ids])
          map-fahrzeuge       (hooks/use-memo #(filter-fahrzeuge pan-to-filter? (dissoc filters :clusters) fahrzeuge
                                                                 {:exclude-selected? false
                                                                  :show-fahrzeuge-on-loads? show-fahrzeuge-on-loads?})
                                              [pan-to-filter? filters fahrzeuge show-fahrzeuge-on-loads?])
          deferred-selected-fahrzeuge @!deferred-selected-fahrzeuge
          deferred-waypoints (hooks/use-memo #(selected->waypoints deferred-selected-fahrzeuge @!sorted-route)
                                             [deferred-selected-fahrzeuge @!sorted-route])
          load-id->transport-attrs (hooks/use-memo #(fahrzeuge->load-id->transport-attrs fahrzeuge) [fahrzeuge])
          loads               (hooks/use-memo #(mapv (fn [load]
                                                       (merge load (get load-id->transport-attrs (:load/id load))))
                                                     raw-loads)
                                              [raw-loads load-id->transport-attrs])
          resize-layout! (fn []
                           (js/requestAnimationFrame (fn []
                                                       (resize-x-by! 0)
                                                       (resize-y-by! 0))))]
      (hooks/use-effect install-perf-api! [])
      (hooks/use-effect #(perf-update! filtered-fahrzeuge selected-fahrzeuge)
                        [filtered-fahrzeuge selected-fahrzeuge])
      (hooks/use-effect
       (fn []
         (let [idle-scheduler (or (.-requestIdleCallback js/window)
                                  (fn [f] (js/setTimeout f 0)))
               idle-canceler (or (.-cancelIdleCallback js/window)
                                 js/clearTimeout)
               !idle-id (atom nil)
               timer (js/setTimeout
                      (fn []
                        (reset! !idle-id
                                (idle-scheduler
                                 #(set-sorted-route! (sorted-route selected-fahrzeuge)))))
                      250)]
           #(do
              (js/clearTimeout timer)
              (when-some [idle-id @!idle-id]
                (idle-canceler idle-id)))))
       [selected-fahrzeuge @!sort-by-distance?])
      (hooks/use-effect
       (fn []
         (let [idle-scheduler (or (.-requestIdleCallback js/window)
                                  (fn [f] (js/setTimeout f 0)))
               idle-canceler (or (.-cancelIdleCallback js/window)
                                 js/clearTimeout)
               !idle-id (atom nil)
               timer (js/setTimeout
                      (fn []
                        (reset! !idle-id (idle-scheduler #(reset! !deferred-selected-fahrzeuge selected-fahrzeuge))))
                      350)]
           #(do
              (js/clearTimeout timer)
              (when-some [idle-id @!idle-id]
                (idle-canceler idle-id)))))
       [selected-fahrzeuge])
      (hooks/use-effect
       (fn []
         (if (and show-waypoints? (seq deferred-waypoints))
           (let [timer (js/setTimeout
                        (fn []
                          (tx! [[:op/assoc-in [:current-route/transient ::fetching-route?] true]])
                          (-> (ductile.ui.transport/mapbox-route (origin-coord (first deferred-selected-fahrzeuge))
                                                                 @!sorted-route
                                                                 true)
                              (.then (fn [^js res]
                                       (tx! [[:op/dissoc-in [:current-route/transient ::fetching-route?]]])
                                       (when (= "Ok" (.-code res))
                                         (ductile.ui.transport/set-route-to-optimized-result! ::route res))))))
                        250)]
             (fn []
               (js/clearTimeout timer)))
           (tx! [[:op/dissoc-in [:current-route/transient ::route]]])))
       [deferred-waypoints deferred-selected-fahrzeuge show-waypoints?])
      (hooks/use-effect #(when-some [the-map @overview-map/!the-map] (.resize the-map)) [show-loads? show-map?])
      (hooks/use-effect resize-layout! [(empty? @!selected-fahrzeuge) show-loads? show-map? show-waypoints?])
      (hooks/use-effect (fn []
                          (js/addEventListener "resize" resize-layout!)
                          #(js/removeEventListener "resize" resize-layout!)))
      [:div.relative.h-full.max-h-full {:id "load-builder-layout"}
       [:div.flex {:style {:height (str "calc(100% - " transports-height "%)")}
                   :class (when show-loads? "pb-6")}
        (when show-map?
          [:div.px-2.h-full {:id "load-builder-map" :style {:width (str (- 100 table-width) "%")}}
           [:div.h-full.flex.flex-col
            [:div.flex.items-center.gap-1
             (let [path-params (:path-params @deframe/!current-route)]
               [:div.rounded-full.leading-none.font-bold.flex.items-center.gap-1.flex-shrink-0
                {:class ["pl-1" "px-2" "py-[2px]" "text-[11px]" "bg-white" "text-indigo-500" "border" "border-indigo-400"]}
                [ui/icon {:size 12} :map-pin]
                (if-let [country-code (:country/code path-params)]
                  (get @deframe/!country-code->label (str/upper-case country-code))
                  (:compound-name path-params))])
             [legend transport/theme]]
            [:div.flex-grow
             [overview-map/view {:standalone? false
                                 :data map-fahrzeuge
                                 :theme transport/theme
                                 :show-flows? show-flows?
                                 :route @!route
                                 :on-load-fn (fn [the-map]
                                               (.on the-map "click" "locationClustersDelivery" (partial on-cluster-clicked the-map))
                                               (.on the-map "click" "unclusteredLocationsDelivery" (partial on-marker-clicked the-map))
                                               (set! (.-isMapLoaded js/window) true))}]]]
           [:div.absolute.group
            {:id "load-builder-resizer"
             :style {:width 18 :margin-left -9 :left (str (- 100 table-width) "%") :top 30 :z-index 19
                     :height (if show-loads?
                               (str "calc(100% - " transports-height "% - 30px - 1.5rem)")
                               "calc(100% - 30px)")}}
            [:div.absolute.top-0.rounded-md.bg-slate-400.w-1.h-full.group-hover:bg-indigo-600.transition-all.pointer-events-none
             {:style {:left 7.5}}]
            [panel/resizer {:axis :x
                            :on-resize-start #(.. (js/document.getElementById "load-builder-layout") -classList (add "select-none"))
                            :on-resize (fn [_ dx _]
                                         (resize-x-by! dx)
                                         (js/requestAnimationFrame
                                          (gf/debounce
                                           #(when-some [the-map @overview-map/!the-map]
                                              (.resize the-map))
                                           100)))
                            :on-resize-end #(do
                                              (.. (js/document.getElementById "load-builder-layout") -classList (remove "select-none"))
                                              (when-some [the-map @overview-map/!the-map]
                                                (.resize the-map)))}]]])
        ^{:key "load-builder-table"}
        [:div.max-h-full.flex.flex-col
         {:id "load-builder-table" :style {:width (str (if show-map? table-width 100) "%")}}
         [:div.flex.gap-6.items-center.px-2.text-xs.shrink-0
          {:style {:height 30}}
          [:div.flex-auto
           (when-let [cluster-filters (seq (:clusters filters))]
             (into [:div.flex.items-center.gap-1 {:data-testid "map-selection-filters"}
                    [ui/badge
                     {:variant :gray
                      :on-close/data-testid "dismiss-map-selection-filters"
                      :on-close (fn []
                                  (tx! [[:op/update :current-route/transient
                                         #(-> %
                                              (dissoc ::selected-marker-ids)
                                              (update ::filters dissoc :clusters))]]))}
                     (tr "Map selection")]]
                   (map (fn [{:as cluster :keys [id postcodes]}]
                          [ui/badge
                           {:variant :primary
                            :on-close (fn []
                                        (let [new-selected-marker-ids (disj @!selected-marker-ids id)
                                              {:keys [clusters]}      filters
                                              clusters'               (remove #(= cluster %) clusters)
                                              filters'                (if (empty? clusters')
                                                                        (dissoc filters :clusters)
                                                                        (assoc filters :clusters clusters'))]
                                          (tx! [[:op/merge-at :current-route/transient
                                                 {::selected-marker-ids new-selected-marker-ids
                                                  ::filters filters'}]])
                                          (.setFeatureState the-map
                                                            (j/lit {:source "locationClusters" :id id})
                                                            (j/lit {:selected false}))
                                          (.setLayoutProperty the-map "unclusteredLocationsDelivery" "icon-image"
                                                              (overview-map/selected-markers-condition new-selected-marker-ids))))}
                           [:div.truncate {:style {:max-width 210}} (str/join ", " postcodes)]]))
                   cluster-filters))]
          (let [vehicle-count (count filtered-fahrzeuge)]
            [:div.text-gray-600.flex.items-center
             {:on-click #(tx! [[:op/assoc-in [:current-route/transient ::clerk-table?] (not clerk-table?)]])
              :data-testid "vehicle-count"
              :data-testval vehicle-count}
             [ui/icon {:size 16 :class "mr-2"} :truck]
             (cond
               (zero? vehicle-count) (tr "no available vehicles to transport")
               (= 1 vehicle-count) (tr "one available vehicle to transport")
               :else (tr "%1 available vehicles to transport" vehicle-count))])
          [settings-menu {:col-settings @(deframe/!localstorage-get :ductile.ui.load-builder/dispatchable-vehicles-col-settings)
                          :on-change #(deframe/localstorage-assoc! :ductile.ui.load-builder/dispatchable-vehicles-col-settings %)
                          :on-modal-open #(deframe/route-assoc! ::dispatchable-vehicles-col-settings-modal? true)
                          :show-fahrzeuge-on-transports? show-fahrzeuge-on-loads?
                          :show-fahrzeuge-on-transports-storage-key storage-key}]]
         [:div.flex.flex-shrink.items-start.max-w-full {:style {:height "calc(100% - 1.6rem)"}}
          [:div.flex.flex-auto.flex-shrink.px-2.h-full.max-w-full
           [dispatchable-fahrzeuge-react-table filtered-fahrzeuge filtered-fahrzeuge base-filtered-fahrzeuge]]
          (when (and show-waypoints? (seq selected-fahrzeuge))
            [:div.pr-2.flex.flex-col.load-builder-route.relative.flex-shrink.h-full.staging-panel.overflow-auto
             {:style {:width waypoints-panel-width}}
             [:div.flex.items-center.justify-end.absolute.right-4.top-2 {:style {:margin-top 1}}]
             [loads-view selected-fahrzeuge]])]]]
       (when show-loads?
         [:<>
          [:div.flex.justify-between
           [:div.bg-red-200.flex-grow
            [:div.absolute
             {:id "load-builder-transports-resizer" :style {:width "100%" :height 27 :bottom (str transports-height "%") :z-index 19}}


             [:div.absolute.w-full
              [:div.flex.items-center.px-2
               [:div.w-full.group.flex.items-center {:style {:height 27}}
                [:div.flex-grow.rounded-md.bg-slate-400.h-1.group-hover:bg-indigo-600.transition-all.pointer-events-none]]

               [:div.absolute.inset-px
                [panel/resizer {:axis :y
                                :on-resize-start #(.. (js/document.getElementById "load-builder-layout") -classList (add "select-none"))
                                :on-resize (fn [_ _ dy]
                                             (resize-y-by! dy)
                                             (js/requestAnimationFrame
                                              (gf/debounce
                                               #(when-some [the-map @overview-map/!the-map]
                                                  (.resize the-map))
                                               100)))
                                :on-resize-end #(do
                                                  (.. (js/document.getElementById "load-builder-layout") -classList (remove "select-none"))
                                                  (when-some [the-map @overview-map/!the-map]
                                                    (.resize the-map)))}]]

               [:div.justify-self-end.pointer-events-auto {:style {:z-index 20}}
                [columns/select-profile-dropdown {:col-settings @(deframe/!localstorage-get :ductile.ui.transport/col-settings)
                                                  :on-change #(deframe/localstorage-assoc! :ductile.ui.transport/col-settings %)
                                                  :on-modal-open #(deframe/route-assoc! :ductile.ui.transport/col-settings-modal? true)}]]]]]]]
          [:div {:id "load-builder-transports-table"
                 :style {:max-height (str transports-height "%") :bottom 0}}
           [:div.flex.w-100.max-h-full.overflow-auto.mx-2.shadow-sm.rounded.border.border-slate-300
            [transports-table loads]]]])])))


(comment
  ; TODO fix transports table links? maybe missing @deframe/!current-compound ?
  ; TODO fix initial lower pane height (too tall) when transports table has few rows

  ; try with many fahrzeuge
  (apply concat (repeat 10 (:fahrzeuge @(deframe/!route-get-in [:fetch :result] {})))))

(defn priority-level [{:transport/keys [appointment-datetime]}]
  (if appointment-datetime
    (- (time/days-between (time/today) appointment-datetime))
    0))

(defn load-builder []
  [:div {:class "-m-5" :style {:height "calc(100dvh - 64px)"}}
   [dispatchable-car-tasks @(deframe/!route-get-in [:fetch :result] {})]])

(defn view [_]
  [load-builder])

(defn map-view [_]
  (.addEventListener js/window "message" overview-map/on-message)
  (let [!pos (atom nil)
        update-pos (fn []
                     (when-not js/document.hidden
                       (let [pos {:x js/window.screenX
                                  :y js/window.screenY
                                  :w (or
                                      js/window.innerWidth
                                      js/document.documentElement.clientWidth
                                      js/document.body.clientWidth)
                                  :h (or
                                      js/window.innerHeight
                                      js/document.documentElement.clientHeight
                                      js/document.body.clientHeight)}]
                         (when (not= pos @!pos)
                           (reset! !pos pos)
                           (localstorage/set-item! "load-builder-map-pos" pos)))))]
    (js/setInterval update-pos 1000)
    (.addEventListener js/window "resize" update-pos)
    (overview-map/post-message! [:send-state])
    (fn [{fahrzeuge :fahrzeuge}]
      (when @overview-map/!state-synced?
        (let [{:keys [storage-key default?]} (show-fahrzeuge-on-transports-setting)
              show-flows?    @!show-flows?
              pan-to-filter? @!pan-to-filter?
              filters        @!filters
              show-fahrzeuge-on-loads? @(deframe/!localstorage-get storage-key default?)]
          [overview-map/view
           {:data        (filter-fahrzeuge pan-to-filter? (dissoc filters :clusters) fahrzeuge
                                           {:exclude-selected? false
                                            :show-fahrzeuge-on-loads? show-fahrzeuge-on-loads?})
            :theme       transport/theme
            :show-flows? show-flows?
            :route       @!route
            :on-load-fn
            (fn [the-map]
              (.on the-map "click" "locationClustersDelivery" (partial on-cluster-clicked the-map))
              (.on the-map "click" "unclusteredLocationsDelivery" (partial on-marker-clicked the-map)))}])))))

(defn render-load-builder [_match]
  [load-builder {}])
